import CommonModal from "@/components/CommonModal";

export default function ServicesModal({
  isOpen,
  services,
  onClose,
}: ServicesModalProps) {
  return (
    <CommonModal
      isOpen={isOpen}
      onComplete={onClose}
      title={"Are you looking to hire a:"}
    >
      <ul className="grid list-none gap-2 pb-4 p-0 m-0">
        {services.map((service) => (
          <li key={service.id}>
            <a
              href={service.href}
              onClick={onClose}
              className="block rounded-lg px-3 py-2 !text-primary hover:bg-default-100 hover:no-underline"
            >
              {service.name}
            </a>
          </li>
        ))}
      </ul>
    </CommonModal>
  );
}

interface ServicesModalProps {
  isOpen: boolean;
  services: ServiceLink[];
  onClose: () => void;
}

interface ServiceLink {
  id: string;
  name: string;
  href: string;
}
